/**
 * Created by anatoly on 10.05.2025
 */

const BackpackWindow = Prefab.createWindow("backpack_window", "backpack_window_prefab_json", {
    theme: () => bundles.backpack_window.jsons.backpack_theme_json
});
